/** Escapes a string for safe interpolation into innerHTML templates. */
export function escapeHtml(value: string): string {
  return value.replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]!);
}

/** Accepts only #rrggbb colours so user palettes can be inlined safely. */
export function safeColour(value: string): string {
  return /^#[0-9a-f]{6}$/i.test(value) ? value : '#ffffff';
}
